// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"57":"index","201":"chatList","224":"register","966":"login"}[chunkId] || chunkId) + "." + {"57":"0a2d41f7","201":"f9a762f5","224":"4f8558b9","698":"96900203","966":"a5fd8674"}[chunkId] + ".css";
};